/**
 * 最后学习的课件及媒体信息
 */
class LastLearningCourseWare {
  /**
   * 课程编号
   */
  courseId = ''
  /**
   * 课件所属章节编号
   */
  chapterId = ''
  /**
   * 课件编号，由于只有单媒体
   */
  coursewareId = ''
}

export default LastLearningCourseWare
